import type { Company } from '../types/company';
import type { CompanyInstance } from '../types/companyInstance';

export type UserCompanyPair = {
  company: Company;
  instance: CompanyInstance;
};

/** Roster switcher: companies with a kryspace workspace slug (header deep-links). */
export function filterRosterMappedCompanies(rows: UserCompanyPair[]): UserCompanyPair[] {
  return rows.filter((row) => Boolean(row.company.kryspace_slug?.trim()));
}
